import useWebSocket from 'react-use-websocket';
import useAsyncEffect from 'use-async-effect';

import {
  LastWebsocketJsonMessageType,
  WebsocketAction,
} from '@interfaces/webSocketConnectionInfo';
import { useGetWebsocketMsg } from '@core/dashboard/components/DashboardContent/hooks';
import { useMytaverse } from '@providers/MytaverseProvider';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { useClientSpecificDirectEntryAvatarGate } from '@hooks/clientSpecificUtils';
import { IStartStreamSessionOutput } from '@interfaces/gamecast';

const DashboardLoading = () => {
  const { activeSocketUrl, getWebSocketOptions } = useMytaverse();

  const { handleGamecastStreamSession } = useMytaverseEvent();

  useClientSpecificDirectEntryAvatarGate();

  const getWebsocketMsg = useGetWebsocketMsg();

  const { lastJsonMessage } = useWebSocket(
    activeSocketUrl,
    getWebSocketOptions({ withReconnection: false }),
  );

  const websocketMsg = getWebsocketMsg(
    lastJsonMessage as LastWebsocketJsonMessageType,
  );

  useAsyncEffect(async () => {
    if (
      websocketMsg &&
      websocketMsg.action === WebsocketAction.GamecastStreamSession &&
      websocketMsg.status
    ) {
      await handleGamecastStreamSession({
        gamecastStreamSession:
          websocketMsg.gamecastStreamSession as IStartStreamSessionOutput,
        status: websocketMsg.status,
        sessionKey: websocketMsg.sessionKey,
      });
    }
  }, [websocketMsg, handleGamecastStreamSession]);

  return null;
};

export default DashboardLoading;
